'use client'
import { useCmsStore } from "@/components/AppHooks"
import { IconClock } from "@/components/icon/master"
import { DdpCta } from "@/components/shared/DdpCta"
import { Popup } from "@/components/shared/Popup"
import { transformDate } from "@/shared/utils"

export function PopupQuizTimeReminder(props: any) {
    const { content, show, onClose } = props
    const { storeConfig: {
        startTime, endTime, nonAlcoholStore
    } } = useCmsStore()!
    const hasNonAlcoholStore = nonAlcoholStore?.id && nonAlcoholStore.cocktailList.length > 0;
    return <Popup className='popup-quiz-time-reminder' show={show && hasNonAlcoholStore} onClose={onClose} >
        <IconClock className="icon-clock" />
        <h2 className="time-reminder-title">{content.title.replace('[#startTime#]', transformDate(startTime)).replace('[#endTime#]', transformDate(endTime))}</h2>
        <div className="time-desc" dangerouslySetInnerHTML={{ __html: content.description.replace('[#endTime#]', transformDate(endTime)) }}></div>
        <DdpCta className="popup-cta" cta={content.cTA} />
    </Popup>
}